import React from 'react';
import { Check, Lock } from 'lucide-react';
import { Link } from 'react-router-dom';

const included = [
  'Todas las funciones de Certy',
  'Detección y búsqueda de certificados',
  'Navegador con varias pestañas',
  'Importación, firma PDF y avisos',
  'Actualizaciones y soporte',
];

const Pricing: React.FC = () => (
  <section id="pricing" className="border-b border-[#c9d2cc] bg-white py-14 md:py-16">
    <div className="mx-auto max-w-[1240px] px-5 sm:px-8 lg:px-10">
      <div className="border-b border-[#c9d2cc] pb-8">
        <h2 className="text-[clamp(2.25rem,3.7vw,4rem)] font-semibold leading-[1] tracking-[-0.05em] text-[#07110d]">Precios.</h2>
        <p className="mt-4 max-w-[54ch] text-base leading-7 text-[#526158]">Una licencia por equipo. Puedes probar la aplicación antes de activarla.</p>
      </div>

      <div className="mt-8 grid gap-5 md:grid-cols-2">
        <article className="rounded-xl border border-[#c9d2cc] bg-white p-7 md:p-9">
          <p className="text-sm font-semibold text-[#526158]">Mensual</p>
          <div className="mt-5 flex items-end gap-2">
            <span className="text-5xl font-semibold tracking-[-0.05em] text-[#07110d]">9,99 €</span>
            <span className="pb-1 text-sm text-[#526158]">al mes</span>
          </div>
          <p className="mt-4 text-sm leading-6 text-[#526158]">Para probar Certy o utilizarlo de forma puntual.</p>
          <ul className="mt-8 space-y-3 border-t border-[#dce2de] pt-7">
            {included.map((feature) => (
              <li key={feature} className="flex items-start gap-3 text-sm text-[#34463b]"><Check className="mt-0.5 h-4 w-4 shrink-0 text-[#15783a]" />{feature}</li>
            ))}
          </ul>
          <Link to="/downloads" className="editorial-button editorial-button-outline-dark mt-9 w-full justify-center">Descargar Certy</Link>
        </article>

        <article className="rounded-xl border border-[#07110d] bg-[#07110d] p-7 text-white md:p-9">
          <div className="flex items-center justify-between gap-4">
            <p className="text-sm font-semibold text-[#c9d7ce]">Anual</p>
            <span className="rounded-full bg-[#85f6aa] px-3 py-1 text-xs font-semibold text-[#07110d]">Recomendado</span>
          </div>
          <div className="mt-5 flex items-end gap-2">
            <span className="text-5xl font-semibold tracking-[-0.05em]">99,99 €</span>
            <span className="pb-1 text-sm text-[#a9b9af]">al año</span>
          </div>
          <p className="mt-4 text-sm leading-6 text-[#c9d7ce]">Equivale a 8,33 € al mes y se renueva una vez al año.</p>
          <ul className="mt-8 space-y-3 border-t border-white/15 pt-7">
            {included.map((feature) => (
              <li key={feature} className="flex items-start gap-3 text-sm text-[#e7eee9]"><Check className="mt-0.5 h-4 w-4 shrink-0 text-[#85f6aa]" />{feature}</li>
            ))}
          </ul>
          <Link to="/downloads" className="editorial-button editorial-button-primary mt-9 w-full justify-center">Descargar Certy</Link>
        </article>
      </div>

      <p className="mt-6 text-center text-sm leading-6 text-[#526158]">Precios sin IVA. Los impuestos aplicables se muestran antes de confirmar el pago.</p>
      <p className="mt-3 flex items-center justify-center gap-2 text-center text-sm text-[#526158]">
        <Lock className="h-4 w-4 text-[#15783a]" /> Pago seguro y gestión de la suscripción desde Certy.
      </p>
    </div>
  </section>
);

export default Pricing;
